import { useEffect, useState } from 'react';
import jwtAxios from '@projectK/services/auth/JWT';
import {
  isStudent,
} from '@projectK/context/RolesProvider';
const WaiverAuthenticate = (user) => {
  const [arr, setArr] = useState(true);
  useEffect(() => {
    const isStudentOrParticipantOnly =
      user?.id &&
      user.role &&
      user.role.length === 1 &&
      (isStudent(user));

    if (isStudentOrParticipantOnly) {
      fetchReportFields();
    }
  }, [user]);

  const fetchReportFields = async () => {
    try {
      if (user?.actualUser.length === 0) {
        const response = await jwtAxios.get(`/userwaiver/user/${user.id}`);
        const { data } = response;
        setArr(data);
      }
    } catch (error) {
      setArr(true);
    }
  };

  return arr;
};

export default WaiverAuthenticate;
